import { render, staticRenderFns } from "./CommunicationTypeList.vue?vue&type=template&id=23fc3415&"
import script from "./CommunicationTypeList.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fc3415')) {
      api.createRecord('23fc3415', component.options)
    } else {
      api.reload('23fc3415', component.options)
    }
    module.hot.accept("./CommunicationTypeList.vue?vue&type=template&id=23fc3415&", function () {
      api.rerender('23fc3415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/communicationTypes/CommunicationTypeList.vue"
export default component.exports